import {
    connect,
    disconnect,
    publish,
    subscribe,
    unsubscribe,
    listen,
} from '@kuyoonjo/tauri-plugin-mqtt';

class MqttService {
    constructor(settings) {
        this.settings = settings;
        this.mqttId = null;
        this.listeners = new Map(); // Store multiple listeners
        this.connectionListeners = new Map();
        this.connected = false; // Track connection status
        this.isListening = false; // Track listening status
        this.mqttTarget = '';
    }

    // Set user settings (e.g., broker URL and plate name)
    setSettings(settings) {
        this.disconnectFromBroker();
        this.settings = settings;
    }

    // Connect to MQTT broker
    async connectToBroker(settings) {
        this.setSettings(settings);
        if (this.connected) {
            return;
        }
        let mqttBrokerUrl = this.settings.mqtt.protocol + '://' + this.settings.mqtt.host + ':' + this.settings.mqtt.port;
        if (this.settings.mqtt.username && this.settings.mqtt.password) {
            mqttBrokerUrl = this.settings.mqtt.protocol + '://' + encodeURIComponent(this.settings.mqtt.username) + ':' + encodeURIComponent(this.settings.mqtt.password) + '@' + this.settings.mqtt.host + ':' + this.settings.mqtt.port;
        }
        if (mqttBrokerUrl !== undefined) {
            // Connect to the broker
            if (mqttBrokerUrl.startsWith('mqtts') || mqttBrokerUrl.startsWith('wss')) {
                await connect(this.settings.mqtt.id, mqttBrokerUrl, { skipVerification: true });
            } else {
                await connect(this.settings.mqtt.id, mqttBrokerUrl);
            }

            this.mqttTarget = 'hasp/' + this.settings.plate.name;
            // Subscribe to a topic
            await subscribe(this.settings.mqtt.id, this.mqttTarget + '/#', 0);

            this.connected = true; // Mark as connected
            this.notifyConnectionListeners('connected');

            // Start the listener
            this.startListening();
        }
    }

    isConnected() {
        return this.connected;
    }

    // Register a listener (callback function)
    registerListener(name, callback) {
        this.listeners.set(name, callback);
    }

    unregisterListener(name) {
        if (this.listeners.has(name)) {
            this.listeners.delete(name);
        }
    }

    registerConnectionListener(name, callback) {
        if (typeof callback === 'function') this.connectionListeners.set(name, callback);
    }

    unregisterConnectionListener(name) {
        this.connectionListeners.delete(name);
    }

    notifyConnectionListeners(status) {
        this.connectionListeners.forEach(listener => listener(status));
    }

    // Start listening for MQTT messages
    startListening() {
        if (!this.isListening) {
            listen((mqttMessage) => {
                const x = mqttMessage?.payload?.event?.message;
                if (!x?.payload) return;
                const payload = x.payload
                    .map((byte) => String.fromCharCode(byte))
                    .join('');
                const currentTime = new Date().toLocaleString();
                this.notifyListeners(currentTime, x.topic, payload);
            });
            this.isListening = true;
        }
    }

    // Notify all registered listeners with the received message
    notifyListeners(timestamp, topic, payload) {
        this.listeners.forEach((listener, name) => {
            listener(timestamp, topic, payload); // Call each listener with the message
        });
    }

    async sendMqttCommand(cmd, payload = '') {
        await publish(this.settings.mqtt.id, this.mqttTarget + cmd, 0, false, payload);
    }

    // Explicitly disconnect from the MQTT broker
    async disconnectFromBroker() {
        // this.listeners.clear(); // Clear all listeners
        if (this.connected) {
            // await unsubscribe(this.settings.mqtt.id, this.mqttTarget + '/#'); //not needed on disconnect all subscriptions are gone
            await disconnect(this.settings.mqtt.id);
            this.connected = false;
            this.notifyConnectionListeners('disconnected');
        } else {
        }
    }
}

// Export an instance of MqttService
const mqttService = new MqttService();

export default mqttService;
